import { useState } from "react";
import { useDispatch } from "react-redux";
import DeleteActionIcon from "../../../../../components/icons/DeleteActionIcon";
import TextWrapper from "../../../../../components/textWrapper/TextWrapper";
import { showConfirmationModal } from "../../../../../features/confirmationModal/ConfirmationModalSlice";
import styles from "./multiPurposeOneImage.module.css";

const MultiPurposeOneImage = ({ path, id, name }) => {
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);

  const handleDeleteImage = () => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متاكد من حذف الصورة ؟",
        data: id,
        actionType: "deleteMultiPurposeImage",
      })
    );
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(path);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
      const textArea = document.createElement("textarea");
      textArea.value = path;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className={styles.oneImageContainer}>
      <div className={styles.headerRow}>
        <TextWrapper textStyle="textSmall">{name}</TextWrapper>
      </div>
      <div className={styles.imageWrapper}>
        <img src={path} alt={name} className={styles.image} />
      </div>
      <div className={styles.actionsRow}>
        <button
          type="button"
          className={styles.deleteImageWrapper}
          onClick={handleDeleteImage}
        >
          <DeleteActionIcon className={styles.svgIcon} />
          <TextWrapper textStyle="textXSmall">حذف الصوره</TextWrapper>
        </button>
        <button
          type="button"
          className={styles.copyLinkWrapper}
          onClick={handleCopyLink}
        >
          <TextWrapper textStyle="textXSmall">
            {copied ? "تم النسخ!" : "نسخ الرابط"}
          </TextWrapper>
        </button>
      </div>
    </div>
  );
};

export default MultiPurposeOneImage;
